import { supabase } from './supabaseService';

export type OutboundCall = {
  id: string;
  outbound_prospect_id: string | null;
  zadarma_call_id: string | null;
  direction: 'inbound' | 'outbound';
  phone: string | null;
  normalized_phone: string | null;
  extension: string | null;
  commercial_name: string | null;
  started_at: string | null;
  duration_seconds: number | null;
  status: string | null;
  audio_url: string | null;
  audio_storage_path: string | null;
  transcript: string | null;
  ai_summary: string | null;
  ai_score: number | null;
  ai_next_action: string | null;
};

export type ProspectCallSummary = {
  count: number;
  lastStatus: string | null;
  hasAudio: boolean;
};

export async function listCallsForProspect(prospectId: string): Promise<OutboundCall[]> {
  const { data, error } = await supabase
    .from('outbound_calls')
    .select('*')
    .eq('outbound_prospect_id', prospectId)
    .order('started_at', { ascending: false });
  if (error) {
    console.error('listCallsForProspect', error);
    return [];
  }
  return (data ?? []) as OutboundCall[];
}

export async function countCallsByProspect(
  prospectIds: string[],
): Promise<Record<string, ProspectCallSummary>> {
  if (prospectIds.length === 0) return {};
  const { data, error } = await supabase
    .from('outbound_calls')
    .select('outbound_prospect_id, status, audio_url, started_at')
    .in('outbound_prospect_id', prospectIds)
    .order('started_at', { ascending: false });
  if (error) {
    console.error('countCallsByProspect', error);
    return {};
  }
  const result: Record<string, ProspectCallSummary> = {};
  for (const row of (data ?? []) as Array<{
    outbound_prospect_id: string;
    status: string | null;
    audio_url: string | null;
    started_at: string | null;
  }>) {
    const pid = row.outbound_prospect_id;
    if (!result[pid]) {
      result[pid] = { count: 0, lastStatus: row.status, hasAudio: false };
    }
    result[pid].count += 1;
    if (row.audio_url) result[pid].hasAudio = true;
  }
  return result;
}

// Stub. Engancha aquí transcripción + análisis IA cuando exista infra.
// Pipeline previsto:
//   1) Descargar audio desde outbound_calls.audio_url
//   2) Subir a Supabase Storage y guardar audio_storage_path
//   3) Transcribir (Whisper, Deepgram u otro) -> transcript
//   4) Analizar con Claude -> ai_summary, ai_score, ai_next_action
//   5) UPDATE outbound_calls SET ... WHERE id = callId
export async function analyzeProspectionCall(_callId: string): Promise<void> {
  throw new Error('analyzeProspectionCall no implementado todavía (pendiente fase IA)');
}
